import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slice/userSlice";
import coursesSlice from "./slice/coursesSlice";

const store = configureStore({
  reducer: {
    userReducer: userSlice,
    coursesReducer: coursesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
